import PremiumTab from './PremiumTab'

export default PremiumTab
